import CryptoJS from "crypto-js";

export const abstartOldUrl = "https://abs.abstarthr.com/";
export const uatabstartOldUrl = "http://uatabs.abstarthr.com/";

export const encodeData = (data) => {
    const queryData = data;
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(queryData),process.env.REACT_APP_SECRET_KEY).toString();
    const encodedQuery = encodeURIComponent(encryptedData);
    return encodedQuery;
  };
export const findModuleById = (modules, id) => {
    for (const module of modules) {
      if (module.id === id) {
        return module;
      }
      
      if (module.sub_module) {
        const found = findModuleById(module.sub_module, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
export const findModuleByRoute = (modules, path) => {
    console.log("modules",modules);
    for (const module of modules) {
        // console.log("module.path",module.path);
      if (module.path === path) {
        return module;
      }
      
      if (module.sub_module) {
        const found = findModuleByRoute(module.sub_module, path);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
export const decodeUrl = (encodedData) => {
    let decodedData = {};
     try {
        const decryptedBytes = CryptoJS.AES.decrypt(
            decodeURIComponent(encodedData),
            process.env.REACT_APP_SECRET_KEY
        );
        decodedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        // console.log("decodedData 1",parseInt(decodedData));
        return decodedData;
        // console.log("decodedData 2",decodedData);
        } catch (error) {
        console.error("Error decrypting query params", error);
        }
    return null;
  };
export const decodeData = (encodedData,permissions) => {
    let decodedData = {};
     try {
        const decryptedBytes = CryptoJS.AES.decrypt(
            decodeURIComponent(encodedData),
            process.env.REACT_APP_SECRET_KEY
        );
        decodedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        // console.log("decodedData 1",parseInt(decodedData));
        // console.info("permissions",permissions);
        // console.log("findModuleById",findModuleById(permissions,decodedData));
        decodedData= findModuleById(permissions,decodedData);
        decodedData= JSON.parse(decodedData?.permissions);

        return decodedData;
        // console.log("decodedData 2",decodedData);
        } catch (error) {
        console.error("Error decrypting query params", error);
        }
    return null;
  };

export const bloodGroupOptions = [
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
];

export const genderOptions = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];
export const titleOptions = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
];
export const emergencyContactPerson = [
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Mom', label: 'Mom' },
  { value: 'Dad', label: 'Dad' },
  { value: 'Cousin', label: 'Cousin' },
];

export const monthData = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const monthDataSelect = [{ value: "Jan", label: "Jan" }, { value: "Feb", label: "Feb" }, { value: "Mar", label: "Mar" }, { value: "Apr", label: "Apr" }, { value: "May", label: "May" }, { value: "Jun", label: "Jun" },
{ value: "Jul", label: "Jul" }, { value: "Aug", label: "Aug" }, { value: "Sep", label: "Sep" }, { value: "Oct", label: "Oct" }, { value: "Nov", label: "Nov" }, { value: "Dec", label: "Dec" }];

export const otTypes=[{ value: "0", label: "Fixed Rate" } ,{ value: "1", label: "1x"},{ value: "1.5", label: "1.5x"}, { value: "2", label: "2x"}]
export const masterCheatCode=[
    {
        name:"Current Date",
        code:"##current_date##"
    },
    {
        name:"Offer Letter Link",
        code:"##offer_letter_link##"
    },
    {
        name:"Appointment Letter Link",
        code:"##appointment_letter_link##"
    },
    {
        name:"Employee Panel Link",
        code:"##employee_panel_url##"
    },
    {
        name:"Data Collection Link",
        code:"##data_collection_link##"
    },
    {
        name:"User Credentials",
        code:"##user_credentials##"
    },
    {
        name:"Company Name",
        code:"##company_name##"
    },
    {
        name:"Employee Code",
        code:"##employee_code##"
    },
    {
        name:"Employee Name",
        code:"##employee_name##"
    },
    {
        name:"Employee Address",
        code:"##employee_address##"
    },
    {
        name:"Department Title",
        code:"##department_title##"
    },
    {
        name:"Designation Title",
        code:"##designation_title##"
    },
    {
        name:"Grade Title",
        code:"##grade_title##"
    },
    {
        name:"Location Title",
        code:"##location_title##"
    },
    {
        name:"Employee Joining Date",
        code:"##employee_joining_date##"
    },
    {
        name:"Salary Amount",
        code:"##salary_amount##"
    },
    // {
    //     name:"CTC Structure",
    //     code:"##ctc_structure##"
    // },
    {
        name:"Signatory",
        code:"##signature_image##"
    },
];
export const emailBoxCheatCode=[
    // {
    //     name:"Current Date",
    //     code:"##current_date##"
    // },
    // {
    //     name:"Employee Panel Link",
    //     code:"##employee_panel_url##"
    // },
    // {
    //     name:"User Credentials",
    //     code:"##user_credentials##"
    // },
    // {
    //     name:"Company Name",
    //     code:"##company_name##"
    // },
    // {
    //     name:"Employee Code",
    //     code:"##employee_code##"
    // },
    // {
    //     name:"Employee Name",
    //     code:"##employee_name##"
    // },
    // {
    //     name:"Employee Address",
    //     code:"##employee_address##"
    // },
    // {
    //     name:"Department Title",
    //     code:"##department_title##"
    // },
    // {
    //     name:"Designation Title",
    //     code:"##designation_title##"
    // },
    // {
    //     name:"Grade Title",
    //     code:"##grade_title##"
    // },
    // {
    //     name:"Location Title",
    //     code:"##location_title##"
    // },
    // {
    //     name:"Signatory",
    //     code:"##signature_image##"
    // },
     {
        name:"Current Date",
        code:"##current_date##"
    },
    {
        name:"Company Name",
        code:"##company_name##"
    },
    {
        name:"Employee Code",
        code:"##employee_code##"
    },
    {
        name:"Employee Name",
        code:"##employee_name##"
    },
    {
        name:"Employee Address",
        code:"##employee_address##"
    },
    {
        name:"Department Title",
        code:"##department_title##"
    },
    {
        name:"Designation Title",
        code:"##designation_title##"
    },
    {
        name:"Grade Title",
        code:"##grade_title##"
    },
    {
        name:"Location Title",
        code:"##location_title##"
    },
    {
        name:"Employee Joining Date",
        code:"##employee_joining_date##"
    },
    // {
    //     name:"Signatory",
    //     code:"##signature_image##"
    // },
]
export const offerLetterCheatCode=[
     {
        name:"Current Date",
        code:"##current_date##"
    },
    {
        name:"Offer Letter Link",
        code:"##offer_letter_link##"
    },
    {
        name:"Appointment Letter Link",
        code:"##appointment_letter_link##"
    },
    {
        name:"Employee Panel Link",
        code:"##employee_panel_url##"
    },
    {
        name:"Data Collection Link",
        code:"##data_collection_link##"
    },
    {
        name:"User Credentials",
        code:"##user_credentials##"
    },
    {
        name:"Company Name",
        code:"##company_name##"
    },
    {
        name:"Employee Code",
        code:"##employee_code##"
    },
    {
        name:"Employee Name",
        code:"##employee_name##"
    },
    {
        name:"Employee Address",
        code:"##employee_address##"
    },
    {
        name:"Department Title",
        code:"##department_title##"
    },
    {
        name:"Designation Title",
        code:"##designation_title##"
    },
    {
        name:"Grade Title",
        code:"##grade_title##"
    },
    {
        name:"Location Title",
        code:"##location_title##"
    },
    {
        name:"Employee Joining Date",
        code:"##employee_joining_date##"
    },
    {
        name:"Salary Amount",
        code:"##salary_amount##"
    },
    // {
    //     name:"CTC Structure",
    //     code:"##ctc_structure##"
    // },
    {
        name:"Signatory",
        code:"##signature_image##"
    },
    // {
    //     name:"Current Date",
    //     code:"##current_date##"
    // },
    // {
    //     name:"Offer Letter Link",
    //     code:"##offer_letter_link##"
    // },
    // {
    //     name:"Employee Name",
    //     code:"##employee_name##"
    // },
    // {
    //     name:"Employee Address",
    //     code:"##employee_address##"
    // },
    // {
    //     name:"Department Title",
    //     code:"##department_title##"
    // },
    // {
    //     name:"Designation Title",
    //     code:"##designation_title##"
    // },
    // {
    //     name:"Grade Title",
    //     code:"##grade_title##"
    // },
    // {
    //     name:"Location Title",
    //     code:"##location_title##"
    // },
    // {
    //     name:"Employee Joining Date",
    //     code:"##employee_joining_date##"
    // },
    // {
    //     name:"Salary Amount",
    //     code:"##salary_amount##"
    // },
    // // {
    // //     name:"CTC Structure",
    // //     code:"##ctc_structure##"
    // // },
    // {
    //     name:"Signatory",
    //     code:"##signature_image##"
    // },
];
export const appointmentLetterCheatCode=[
    {
        name:"Current Date",
        code:"##current_date##"
    },
    {
        name:"Appointment Letter Link",
        code:"##appointment_letter_link##"
    },
    {
        name:"Employee Code",
        code:"##employee_code##"
    },
    {
        name:"Employee Name",
        code:"##employee_name##"
    },
    {
        name:"Department Title",
        code:"##department_title##"
    },
    {
        name:"Designation Title",
        code:"##designation_title##"
    },
    {
        name:"Employee Address",
        code:"##employee_address##"
    },
    {
        name:"Grade Title",
        code:"##grade_title##"
    },
    {
        name:"Location Title",
        code:"##location_title##"
    },
    {
        name:"Employee Joining Date",
        code:"##employee_joining_date##"
    },
    {
        name:"Signatory",
        code:"##signature_image##"
    },
];
 // get month year fromat
 export const formatMonthYear = (monthYear) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Check if input is already in correct format (e.g., "Jan-2025")
    if (/^[A-Za-z]{3}-\d{4}$/.test(monthYear)) {
        return monthYear; // Return as is if it matches "Jan-YYYY" format
    }

    // Check for "Jan-25" and convert it to "Jan-2025"
    const shortYearMatch = monthYear.match(/^([A-Za-z]{3})-(\d{2})$/);
    if (shortYearMatch) {
        const [_, monthStr, shortYear] = shortYearMatch;
        if (monthNames.includes(monthStr)) {
            return `${monthStr}-20${shortYear}`;
        }
        return ""; // Invalid month abbreviation
    }

    // Check if the input is in "M-YYYY" or "MM-YYYY" numeric format
    const parts = monthYear.split('-');
    if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) {
        return ""; // Invalid format
    }

    const [month, year] = parts.map(Number);
    
    // Validate month and year range
    if (month < 1 || month > 12 || year < 0 || year > 99 && year < 1000 || year > 9999) {
        return ""; // Invalid month or year
    }

    // Convert 2-digit year to 4-digit (assume 2000+)
    const fullYear = year < 100 ? 2000 + year : year;

    return `${monthNames[month - 1]}-${fullYear}`;
};
export function isNumeric(input) {
    // Check if the input is a string and use a regular expression to check if the string contains only up to 3 digits
    const regex = /^([0-9]{1,3})?$/;
    return typeof input === 'string' && regex.test(input);
}

export function isNumericTill31(input) {
    // Check if the input is a string
    if (typeof input !== 'string') {
        return false;
    }
    // Convert the string to a number
    const number = Number(input);
    // Check if the number is between 1 and 12 (inclusive) and if the input is a valid number
    return number >= 0 && number <= 31 && input.trim() !== '';
}
export function isNumericTillGivenNumber(input, num = 1) {
    // Check if the input is a string
    if (typeof input !== 'string') {
        return false;
    }
    if (typeof num === 'string') {
        return false;
    }
    // Convert the string to a number
    const number = Number(input);
    // Check if the number is between 1 and 12 (inclusive) and if the input is a valid number
    return number >= 0 && number <= num && input.trim() !== '';
}

export function isNumericWithDot(input) {
    // Regular expression to check if the input is either empty, contains only digits,
    // or contains digits with at most one dot followed by up to two digits.
    // Additionally, ensures that if there is a dot, there must be at least one digit before it.
    const regex = /^\d{0,2}(\.\d{0,2})?$/;
    // Test the input against the regular expression
    return regex.test(input);
}

// get current date and time
export const currentDateAndTime = (isT) => {
    const timeZone = 'Asia/Kolkata';

    const now = new Date();

    // Get date in YYYY-MM-DD format
    const date = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(now); // 'YYYY-MM-DD'

    // Get time in HH:mm:ss format (24-hour)
    const time = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(now); // 'HH:mm:ss'

    return isT === 'T' ? `${date}T${time}` : `${date} ${time}`;
}
// export const currentDateAndTime = (isT) => {
//     // Options to format time in 24-hour format
//     let options = { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' };
//     let formattedTime = new Date().toLocaleTimeString(undefined, options);
//     let dateTime;
//     if (isT === "T") {
//         dateTime = `${new Date().toISOString()?.split("T")[0]}T${formattedTime}`;
//     }
//     else {
//         dateTime = `${new Date().toISOString()?.split("T")[0]} ${formattedTime}`;
//     }

//     // console.log("new Date().toLocaleTimeString()", dateTime);
//     return dateTime
// }

export function formatDateWithTime(isDate) {
    // let options = { hour12: true, hour: '2-digit', minute: '2-digit' };
    let date=new Date(isDate);
    if(!isDate){
        date = new Date();
    }
     // This uses the user's device date and time

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate().toString().padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    // Time options for HH:MM AM/PM format
    const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const time = date.toLocaleTimeString(undefined, timeOptions); // Using undefined to use user's locale

    return `${formattedDate} ${time}`;
}
export function getFormatedDate() {
    // let options = { hour12: true, hour: '2-digit', minute: '2-digit' };
    const date = new Date(); // This uses the user's device date and time

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate().toString().padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    // Time options for HH:MM AM/PM format
    const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const time = date.toLocaleTimeString(undefined, timeOptions); // Using undefined to use user's locale

    return `${formattedDate}`;
}

// get date of next month before date of given month. like if my given date is 2024-03-07.
// then date of next month will be 2024-04-06.
export function getNextMonthBeforeDate(startDate) {
    // Parse the start date to a Date object
    const date = new Date(startDate);

    // Increment the month by 1 to move to the next month
    date.setMonth(date.getMonth() + 1);

    // Subtract 1 day to get the day before the same day in the next month
    date.setDate(date.getDate() - 1);

    // Return the formatted date
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function isValidAttendanceCycle(fromDay, toDay) {
    const currentDate = new Date(); // Current date to infer the month and year

    // Build 'from' date using the current month and year
    let fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), fromDay);

    // Build 'to' date, accounting for possible month rollover
    let toDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), toDay);
    if (parseInt(fromDay) > 20) {
        // If 'toDay' is earlier in the calendar, assume it's in the next month
        fromDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, fromDay);
        // toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, toDay);
    }
    // else if(parseInt(fromDay) <= 20){
    //     toDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, toDay);
    // }
// console.log("toDate - fromDate",toDate, fromDate);
    // Calculate the difference in days
    const diffInMilliseconds = toDate - fromDate;
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

    // Check if the difference is between 28 and 31 days
    // if(diffInDays >= 28 && diffInDays <= 31){
    //     return diffInDays >= 28 && diffInDays <= 31;
    // }
    // else if(!diffInDays >= 28){
    //     return "less";
    // }
    // else if(!diffInDays <= 31){
    //     return "more";
    // }
    // else{
    let result= {isTrue:diffInDays >= 28 && diffInDays <= 31, days:diffInDays}
        return result;
    // }
    
}

export function calculateAge(dob, currentDate) {
    // Parse the input dates
    const birthDate = new Date(dob);
    const today = new Date(currentDate);

    // Calculate the difference in years
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust if the birthdate hasn't occurred yet this year
    if (
        today.getMonth() < birthDate.getMonth() || 
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }
    return age;
}
// used for add margin bottom zero in p tag 
export const sanitizeHtmlContent=(htmlContent)=> {
    return htmlContent.replace(/<p([^>]*)>/g, '<p$1 style="margin-bottom: 0;">');
}
// used for render split content in frontend
// original
// export const renderPages=(company_letter_content, letterhead_url, markings)=> {
//     const pageHeight = 297;
//     const marginTop = parseInt(markings?.split(",")[0] || 0, 10);
//     const marginBottom = parseInt(markings?.split(",")[1] || 0, 10);
//     const marginLeft = parseInt(markings?.split(",")[3] || 0, 10);
//     const marginRight = parseInt(markings?.split(",")[2] || 0, 10);
//     const contentHeight = pageHeight - (marginTop + marginBottom);
//     const maxOverflow = contentHeight + 3; // Allowable overflow threshold
  
//     const tempDiv = document.createElement("div");
//     tempDiv.style.position = "absolute";
//     tempDiv.style.width = "210mm";
//     tempDiv.style.visibility = "hidden";
//     tempDiv.style.fontSize = "14px";
//     tempDiv.innerHTML = sanitizeHtmlContent(company_letter_content);
  
//     document.body.appendChild(tempDiv);
  
//     const pages = [];
//     let currentPage = "";
//     let totalHeight = 0;
//     let prevContent = "";
//     let prevHeight = 0;
  
//     Array.from(tempDiv.childNodes).forEach((node) => {
//       const clone = node.cloneNode(true);
//       tempDiv.innerHTML = "";
//       tempDiv.appendChild(clone);
  
//       const computedStyle = window.getComputedStyle(tempDiv);
//     const marginPaddingHeight = 
//         parseFloat(computedStyle.marginTop) + 
//         parseFloat(computedStyle.marginBottom) + 
//         parseFloat(computedStyle.paddingTop) + 
//         parseFloat(computedStyle.paddingBottom);

//         const nodeHeight = (tempDiv.scrollHeight + marginPaddingHeight) / 3.77953;
//         const projectedHeight = totalHeight + nodeHeight;

//         if (projectedHeight <= contentHeight) {
//           prevContent = currentPage;
//           prevHeight = totalHeight;
//           currentPage += node.outerHTML;
//           totalHeight = projectedHeight;
//         } else if (projectedHeight <= maxOverflow) {
//           prevContent = currentPage;
//           prevHeight = totalHeight;
//           currentPage += node.outerHTML;
//           totalHeight = projectedHeight;
//         } else {
//         // Overflow too large, use previous content
//         // console.log("Overflow detected, breaking page:", node.outerHTML, "Height:", nodeHeight);
//         // console.log("prevHeight, projectedHeight,contentHeight",prevHeight,projectedHeight,contentHeight);
//         if (prevHeight > 0) {
//           pages.push(prevContent); // Add previous content as a page
//           currentPage = node.outerHTML; // Start new page with current node
//           totalHeight = nodeHeight; // Reset height for new page
//           prevContent = "";
//           prevHeight = 0;
//         } else {
//         //   console.log("Overflow detected, breaking page:", node.outerHTML, "Height:", nodeHeight);
//         //   console.log("prevHeight, projectedHeight,contentHeight",prevHeight,projectedHeight,contentHeight);
//           // If no previous content, force add the current node to a new page
//           pages.push(currentPage);
//           currentPage = node.outerHTML;
//           totalHeight = nodeHeight;
//         }
//       }
//     });
  
//     if (currentPage) {
//       pages.push(currentPage); // Add any remaining content as a page
//     }
  
//     document.body.removeChild(tempDiv);

//     // console.log("page",pages.len);
  
//     return pages.map((pageContent, index) => (
//       <div
//         key={index}
//         className="bubble-editor"
//         style={{
//           position: "relative",
//           height: `${pageHeight}mm`,
//           border: "1px solid #F3F3F9",
//         }}
//       >
//         {letterhead_url && (
//           <img
//             src={letterhead_url}
//             alt="Letterhead"
//             style={{ position: "absolute", width: "100%", height: "297mm" }}
//           />
//         )}
//         <div
//           dangerouslySetInnerHTML={{ __html: pageContent }}
//           style={{
//             position: "relative",
//             margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
//             boxSizing: "border-box",
//             wordWrap: "break-word",
//             height: `${contentHeight}mm`,
//           }}
//         />
//       </div>
//     ));
  
// }

export const renderPages=(company_letter_content, letterhead_url, markings)=>{
    const pageHeight = 297;
    const marginTop = parseInt(markings?.split(",")[0] || 0, 10);
    const marginBottom = parseInt(markings?.split(",")[1] || 0, 10);
    const marginLeft = parseInt(markings?.split(",")[3] || 0, 10);
    const marginRight = parseInt(markings?.split(",")[2] || 0, 10);
    // const content= company_letter_content.replace(/(&nbsp;)+/g, ' ');
    const contentHeight = pageHeight - (marginTop + marginBottom);
    console.log("contentHeight",contentHeight);
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.width = "210mm";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.fontSize = "14px";
    tempDiv.innerHTML = sanitizeHtmlContent(company_letter_content);

    document.body.appendChild(tempDiv);

    const pages = [];
    let currentPage = "";
    let totalHeight = 0;

    Array.from(tempDiv.childNodes).forEach((node) => {
      const clone = node.cloneNode(true);
      tempDiv.innerHTML = "";
      tempDiv.appendChild(clone);

      const nodeHeight = tempDiv.scrollHeight / 3.77953;
      totalHeight += nodeHeight;
      
      // console.log("totalHeight , contentHeight",totalHeight , contentHeight);
      if (totalHeight <= contentHeight) {
        currentPage += node.outerHTML;
      } else {
        console.log("totalHeight , contentHeight",totalHeight , contentHeight);
        console.log("totalHeight <= contentHeight",totalHeight > contentHeight);
        pages.push(currentPage);
        currentPage = node.outerHTML;
        totalHeight = nodeHeight;
      }
    });

    if (currentPage) pages.push(currentPage);

    document.body.removeChild(tempDiv);

    console.log("pages",pages);

    // this.setState({ pdfPages:pages });

    return pages.map((pageContent, index) => (
      <div
        key={index}
        className="bubble-editor"
        style={{
          position: "relative",
          // width: "210mm",
          height: `${pageHeight}mm`,
          // marginTop: `${marginTop}mm`,
          // marginBottom: `${marginBottom}mm`,
          border: "1px solid #F3F3F9",
        }}
      >
        {letterhead_url && (
          <img
            src={letterhead_url}
            alt="Letterhead"
            style={{ position: "absolute", width: "100%", height: "297mm" }}
          />
        )}
        <div
          dangerouslySetInnerHTML={{ __html: pageContent }}
          style={{
            position: "relative",
            margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
            boxSizing: "border-box",
            // overflow: "hidden",
            wordWrap: "break-word",
            height: `${contentHeight}mm`,
          }}
        />
      </div>
    ));
  }
// used for letter content split
// export const createPages=(company_letter_content, letterhead_url, markings)=> {
//     // const { company_letter_content, letterhead_url, markings } = this.state;
//     const pageHeight = 297;
//     const marginTop = parseInt(markings.split(",")[0] || 0, 10);
//     const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
//     const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
//     const marginRight = parseInt(markings.split(",")[2] || 0, 10);

//     const contentHeight = pageHeight - marginTop - marginBottom;

//     const tempDiv = document.createElement("div");
//     tempDiv.style.position = "absolute";
//     tempDiv.style.width = "210mm";
//     tempDiv.style.visibility = "hidden";
//     tempDiv.style.fontSize = "14px";
//     tempDiv.innerHTML = company_letter_content;

//     document.body.appendChild(tempDiv);

//     const pages = [];
//     let currentPage = "";
//     let totalHeight = 0;

//     Array.from(tempDiv.childNodes).forEach((node) => {
//       const clone = node.cloneNode(true);
//       tempDiv.innerHTML = "";
//       tempDiv.appendChild(clone);

//       const nodeHeight = tempDiv.scrollHeight / 3.77953;
//       totalHeight += nodeHeight;

//       if (totalHeight <= contentHeight) {
//         currentPage += node.outerHTML;
//       } else {
//         pages.push(currentPage);
//         currentPage = node.outerHTML;
//         totalHeight = nodeHeight;
//       }
//     });

//     if (currentPage) pages.push(currentPage);

//     document.body.removeChild(tempDiv);

//     const cleanedPages = pages.map(page => page.replace(/<p>&nbsp;<\/p>/g, ''));

//     console.log("cleanedPages",cleanedPages?.length);

//     return cleanedPages || [];
//   }
export const createPages = (company_letter_content, letterhead_url, markings) => {
    const pageHeight = 297;
    const marginTop = parseInt(markings?.split(",")[0] || 0, 10);
    const marginBottom = parseInt(markings?.split(",")[1] || 0, 10);
    const marginLeft = parseInt(markings?.split(",")[3] || 0, 10);
    const marginRight = parseInt(markings?.split(",")[2] || 0, 10);
    const contentHeight = pageHeight - (marginTop + marginBottom);
    const maxOverflow = contentHeight + 3; // Allowable overflow threshold
  
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.width = "210mm";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.fontSize = "14px";
    tempDiv.innerHTML = sanitizeHtmlContent(company_letter_content);
  
    document.body.appendChild(tempDiv);
  
    const pages = [];
    let currentPage = "";
    let totalHeight = 0;
    let prevContent = ""; 
    let prevHeight = 0;
  
    Array.from(tempDiv.childNodes).forEach((node) => {
      const clone = node.cloneNode(true);
      tempDiv.innerHTML = "";
      tempDiv.appendChild(clone);
  
      const computedStyle = window.getComputedStyle(tempDiv);
      const marginPaddingHeight =
        parseFloat(computedStyle.marginTop) +
        parseFloat(computedStyle.marginBottom) +
        parseFloat(computedStyle.paddingTop) +
        parseFloat(computedStyle.paddingBottom);
  
      const nodeHeight = (tempDiv.scrollHeight + marginPaddingHeight) / 3.77953;
      const projectedHeight = totalHeight + nodeHeight;
  
      if (projectedHeight <= contentHeight) {
        prevContent = currentPage;
        prevHeight = totalHeight;
        currentPage += node.outerHTML;
        totalHeight = projectedHeight;
      } else if (projectedHeight <= maxOverflow) {
        prevContent = currentPage;
        prevHeight = totalHeight;
        currentPage += node.outerHTML;
        totalHeight = projectedHeight;
      } else {
        // Overflow too large, use previous content
        if (prevHeight > 0) {
          pages.push(prevContent); // Add previous content as a page
          currentPage = node.outerHTML; // Start new page with current node
          totalHeight = nodeHeight; // Reset height for new page
          prevContent = ""; // Reset prevContent to avoid reuse
          prevHeight = 0;
        } else {
          // If no previous content, force add the current node to a new page
          pages.push(currentPage);
          currentPage = node.outerHTML;
          totalHeight = nodeHeight;
        }
      }
    });
  
    if (currentPage) {
      pages.push(currentPage); // Ensure the last page is added
    }
  
    document.body.removeChild(tempDiv);
  
    // const cleanedPages = pages.map(page => page.replace(/<p>&nbsp;<\/p>/g, ''));
    let cleanedPages = pages.map(page =>  page.replace(/<p[^>]*>&nbsp;<\/p>/g, ''));
    cleanedPages = cleanedPages.map(page =>  page.replace(/<h1[^>]*>&nbsp;<\/h1>/g, ''));
    cleanedPages = cleanedPages.map(page =>  page.replace(/<h2[^>]*>&nbsp;<\/h2>/g, ''));
    cleanedPages = cleanedPages.map(page =>  page.replace(/<h3[^>]*>&nbsp;<\/h3>/g, ''));
    // const cleanedPages = pages.map(page =>page.replace(/<p style="margin-bottom: 0;">&nbsp;<\/p>/g, ''));
    // console.log("cleanedPages", cleanedPages);
  
    return cleanedPages || [];
  };

export const isNumericValue = (value)=> {
    return !isNaN(parseFloat(value)) && isFinite(value);
}

export const filterModules = (modules) => {
    let result = [];
  
    const traverse = (items) => {
      for (const item of items) {
        result.push({ value: item.header_id, label: item.name });
  
        if (item.sub_module && item.sub_module.length > 0) {
          traverse(item.sub_module);
        }
      }
    };
  
    traverse(modules);
    return result;
  };
  

  export const validateDateOnly = (inputDate) => {
    if (!inputDate || typeof inputDate !== "string") return "--";
  
    const parsedDate = new Date(inputDate);
    if (isNaN(parsedDate.getTime())) {
      // If not a valid date, return original input as-is
      return inputDate;
    }
  
    // Return formatted date only
    const yyyy = parsedDate.getFullYear();
    const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const dd = String(parsedDate.getDate()).padStart(2, "0");
  
    return `${yyyy}-${mm}-${dd}`;
  };
  
  export const formatDateTimeSafe = (inputDate) => {
    if (!inputDate) return "--";
  
    const parsedDate = new Date(inputDate);
    if (isNaN(parsedDate.getTime())) {
      return inputDate; // fallback: return original string if parsing fails
    }
  
    const yyyy = parsedDate.getFullYear();
    const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const dd = String(parsedDate.getDate()).padStart(2, "0");
  
    const hours = String(parsedDate.getHours()).padStart(2, "0");
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
    const seconds = String(parsedDate.getSeconds()).padStart(2, "0");
  
    return `${yyyy}-${mm}-${dd} ${hours}:${minutes}:${seconds}`;
  };

export const bankList = [
//   { value: "Axis Bank", label: "Axis Bank", code: "UTIB" },
//   { value: "Bandhan Bank", label: "Bandhan Bank", code: "BDBL" },
//   { value: "Bank of Baroda", label: "Bank of Baroda", code: "BARB" },
//   { value: "Bank of India", label: "Bank of India", code: "BKID" },
//   { value: "Bank of Maharashtra", label: "Bank of Maharashtra", code: "MAHB" },
//   { value: "Canara Bank", label: "Canara Bank", code: "CNRB" },
//   { value: "Central Bank of India", label: "Central Bank of India", code: "CBIN" },
//   { value: "Dhanlaxmi Bank", label: "Dhanlaxmi Bank", code: "DLXB" },
//   { value: "Federal Bank", label: "Federal Bank", code: "FDRL" },
//   { value: "HDFC Bank", label: "HDFC Bank", code: "HDFC" },
  { value: "ICICI Bank", label: "ICICI Bank", code: "ICIC" },
//   { value: "IDBI Bank", label: "IDBI Bank", code: "IBKL" },
  { value: "IDFC First Bank", label: "IDFC First Bank", code: "IDFB" },
//   { value: "Indian Bank", label: "Indian Bank", code: "IDIB" },
//   { value: "Indian Overseas Bank", label: "Indian Overseas Bank", code: "IOBA" },
//   { value: "IndusInd Bank", label: "IndusInd Bank", code: "INDB" },
//   { value: "Jammu & Kashmir Bank", label: "Jammu & Kashmir Bank", code: "JAKA" },
//   { value: "Karur Vysya Bank", label: "Karur Vysya Bank", code: "KVBL" },
//   { value: "Kotak Mahindra Bank", label: "Kotak Mahindra Bank", code: "KKBK" },
//   { value: "Punjab National Bank", label: "Punjab National Bank", code: "PUNB" },
//   { value: "State Bank of India", label: "State Bank of India", code: "SBIN" },
//   { value: "Union Bank of India", label: "Union Bank of India", code: "UBIN" },
//   { value: "Yes Bank", label: "Yes Bank", code: "YESB" },
//   { value: "UCO Bank", label: "UCO Bank", code: "UCBA" },
//   { value: "South Indian Bank", label: "South Indian Bank", code: "SIBL" },
//   { value: "RBL Bank", label: "RBL Bank", code: "RATN" },
//   { value: "AU Small Finance Bank", label: "AU Small Finance Bank", code: "AUBL" },
//   { value: "Equitas Small Finance Bank", label: "Equitas Small Finance Bank", code: "ESFB" },
//   { value: "Suryoday Small Finance Bank", label: "Suryoday Small Finance Bank", code: "SURY" },
//   { value: "Ujjivan Small Finance Bank", label: "Ujjivan Small Finance Bank", code: "UJVN" },
//   { value: "Jana Small Finance Bank", label: "Jana Small Finance Bank", code: "JSFB" },
]; 

// Marital Status
export const maritalStatusOptions = [
  {value: "Single", label: "Single"},
  {value: "Married", label: "Married"},
  {value: "Separated", label: "Separated"},
  {value: "Widowed", label: "Widowed"},
  {value: "Widower", label: "Widower"},
];
